"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fields = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdColorPicker = _interopRequireWildcard(require("cccisd-color-picker"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var colorFields = ['displayOptions.portal.titleColor', 'displayOptions.portal.infoBarAccentColor', 'displayOptions.portal.searchBarColor', 'displayOptions.portal.backgroundColor', 'displayOptions.portal.filterHeaderColor', 'displayOptions.portal.filterHeaderBackgroundColor', 'displayOptions.portal.filterCollapseColor', 'displayOptions.portal.filterGroupColor', 'displayOptions.portal.tabActiveColor', 'displayOptions.portal.tabInactiveColor', 'displayOptions.portal.tabTextColor', 'displayOptions.portal.tabTextActiveColor', 'displayOptions.portal.resourceCountLabelColor', 'displayOptions.portal.defaultPerPageOption', 'displayOptions.portal.infoBarTextColor', 'displayOptions.portal.filterGroupTextColor', 'displayOptions.resources.titleColor', 'displayOptions.resources.shareButtonColor', 'displayOptions.resources.descriptionTextColor'];
var fields = exports.fields = [].concat(colorFields);
var _default = exports["default"] = function _default(props) {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showColorOptions = _useState2[0],
    handleShowColorOptions = _useState2[1];
  var displayOptions = props.fields.displayOptions;
  var _displayOptions$porta = displayOptions.portal,
    titleColor = _displayOptions$porta.titleColor,
    infoBarAccentColor = _displayOptions$porta.infoBarAccentColor,
    searchBarColor = _displayOptions$porta.searchBarColor,
    backgroundColor = _displayOptions$porta.backgroundColor,
    filterHeaderColor = _displayOptions$porta.filterHeaderColor,
    filterHeaderBackgroundColor = _displayOptions$porta.filterHeaderBackgroundColor,
    filterCollapseColor = _displayOptions$porta.filterCollapseColor,
    filterGroupColor = _displayOptions$porta.filterGroupColor,
    tabActiveColor = _displayOptions$porta.tabActiveColor,
    tabInactiveColor = _displayOptions$porta.tabInactiveColor,
    tabTextColor = _displayOptions$porta.tabTextColor,
    tabTextActiveColor = _displayOptions$porta.tabTextActiveColor,
    resourceCountLabelColor = _displayOptions$porta.resourceCountLabelColor,
    infoBarTextColor = _displayOptions$porta.infoBarTextColor,
    filterGroupTextColor = _displayOptions$porta.filterGroupTextColor;
  var _displayOptions$resou = displayOptions.resources,
    shareButtonColor = _displayOptions$resou.shareButtonColor,
    descriptionTextColor = _displayOptions$resou.descriptionTextColor;
  var colors = [{
    field: titleColor,
    label: 'Title Color'
  }, {
    field: infoBarAccentColor,
    label: 'Info Bar Accent Color'
  }, {
    field: searchBarColor,
    label: 'Search Bar Color'
  }, {
    field: backgroundColor,
    label: 'Background Color'
  }, {
    field: filterHeaderColor,
    label: 'Filter Header Color'
  }, {
    field: filterHeaderBackgroundColor,
    label: 'Filter Header BG Color'
  }, {
    field: filterCollapseColor,
    label: 'Filter Collapse Color'
  }, {
    field: filterGroupColor,
    label: 'Filter Group Color'
  }, {
    field: tabActiveColor,
    label: 'Tab Active Color'
  }, {
    field: tabInactiveColor,
    label: 'Tab Inactive Color'
  }, {
    field: tabTextColor,
    label: 'Inactive Tab Text Color'
  }, {
    field: tabTextActiveColor,
    label: 'Active Tab Text Color'
  }, {
    field: resourceCountLabelColor,
    label: 'Resource Count Label Color'
  }, {
    field: displayOptions.resources.titleColor,
    label: 'Resource Title Color'
  }, {
    field: shareButtonColor,
    label: 'Share Button Color'
  }, {
    field: infoBarTextColor,
    label: 'Header Text Color'
  }];
  var handleChange = function handleChange(color, fieldsList) {
    color = (0, _cccisdColorPicker.getColor)(color);
    fieldsList.forEach(function (field) {
      return field.onChange(color);
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "well"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-3"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: tabActiveColor,
    label: "Primary Color"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdColorPicker["default"], {
    value: tabActiveColor.value,
    onChange: function onChange(color) {
      return handleChange(color, [tabActiveColor]);
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-3"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: infoBarAccentColor,
    label: "Secondary Color"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdColorPicker["default"], {
    value: infoBarAccentColor.value,
    onChange: function onChange(color) {
      return handleChange(color, [infoBarAccentColor, shareButtonColor, filterCollapseColor]);
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-3"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: titleColor,
    label: "Primary Text Color"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdColorPicker["default"], {
    value: titleColor.value,
    onChange: function onChange(color) {
      return handleChange(color, [titleColor, displayOptions.resources.titleColor, filterHeaderColor]);
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-3"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: descriptionTextColor,
    label: "Secondary Text Color"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdColorPicker["default"], {
    value: descriptionTextColor.value,
    onChange: function onChange(color) {
      return handleChange(color, [descriptionTextColor, filterGroupTextColor, resourceCountLabelColor]);
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-12",
    style: {
      marginBottom: '15px'
    }
  }, /*#__PURE__*/_react["default"].createElement("a", {
    onClick: function onClick() {
      return handleShowColorOptions(function (prevState) {
        return !prevState;
      });
    }
  }, showColorOptions ? 'Nevermind...' : 'I need finer control...')), showColorOptions && colors.map(function (color) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-xs-3",
      key: color.label
    }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
      field: color.field,
      label: color.label
    }, /*#__PURE__*/_react["default"].createElement(_cccisdColorPicker["default"], {
      value: color.field.value,
      onChange: function onChange(c) {
        return color.field.onChange((0, _cccisdColorPicker.getColor)(c));
      }
    })));
  })));
};